
export enum TrainingStepState
{
    NotPlannedYet = "NotPlannedYet",
    Planning = "Planning",
    Planned = "Planned",
    Done = "Done",
    Canceling = "Canceling",
    Cancelled = "Cancelled",
    Undone = "Undone",
    Self = "Self", 
}
